<template>
    
    <!--<a-entity>-->
      <a-scene vr-mode-ui="enabled: false" loading-screen="enabled:false">
  <a-entity sound="src: #drops" id="theDrops"></a-entity>

      <a-assets>
          <audio id="drops" src="static/intro/drops.mp3" preload loop></audio>

    <img id="masthead" src="static/intro/masthead-tq.png">
    <img id="octo" src="static/intro/blue-leftln1.jpg">
    <img id="fish1" src="static/intro/img/blue-stillsq1.jpg">
    <img id="fish2" src="static/intro/img/blue-stillsq2.jpg">
    <img id="fish3" src="static/intro/img/blue-stillsq3.jpg">
    <img id="star1" src="static/intro/img/blue-stillrg3.jpg">
    <img id="star2" src="static/intro/img/blue-stillrg6.jpg">

<img id="squirm" src="static/intro/img/blue-leftsq2.jpg">

<img id="squirm2" src="static/intro/img/blue-leftsq3.jpg">
<img id="squirm3" src="static/intro/img/blue-leftsq4.jpg">

  </a-assets>

 <a-entity >
<a-curvedimage src="#squirm"  height="40" theta-length="80" radius="20" position="0 0 0" rotation="0 0 0" alpha-test animation="property:rotation;
               dur:180000; easing:linear;to: 0 360 0; 
               loop: true;" opacity="0.2" ></a-curvedimage >

</a-entity>


 <a-entity >
<a-curvedimage src="#squirm3" rotation="0 120 0" height="40" theta-length="80"  radius="20" position="0 0 0" alpha-test animation="property:rotation;
               dur:180000; easing:linear;to: 0 480 0; 
               loop: true;" opacity="0.2" ></a-curvedimage >

</a-entity>

 <a-entity >
<a-curvedimage src="#squirm2"  rotation="0 240 0" height="40" theta-length="80" radius="20"  position="0 0 0" alpha-test animation="property:rotation;
               dur:180000; easing:linear;to: 0 600 0; 
               loop: true;" opacity="0.2" ></a-curvedimage >

</a-entity>




  <a-entity position="0 1 -2" rotation="-5 0 0" id="target" >
 <a-entity>
<a-image src="#octo" width="15" height="15" position="0 2.5 -12" alpha-test opacity="0.5" animation="property: position; to: 0 3 -11; dir: alternate;dur: 5000;easing: linear; loop: true"
></a-image>


</a-entity>

<a-entity position="-4 2 -6" rotation="0 60 0" >
<a-image src="#fish1" width="4" height="8"></a-image></a-entity>



      <a-entity position="4 2 -6" rotation="0 -60 0"  >
<a-image src="#fish2" width="4" height="8"></a-image></a-entity>
  

     <a-entity position="-6.6 2 -8" rotation="0 45 0"  >
<a-image src="#fish3" width="6" height="12"></a-image></a-entity>

      <a-entity position="6.6 2 -8" rotation="0 -45 0" >
<a-image src="#fish3" width="6" height="12" ></a-image></a-entity>



<a-image src="#masthead" width="8" height="8" position="0 2 -4" alpha-test></a-image>


</a-entity>


      <a-sky color="#02154F"></a-sky>

<a-entity light="color: #AFA; intensity: 1.5" position="-1 1 0"></a-entity>



    <a-entity  camera orbit-controls="
              target: 0 1 -2;initialPosition: 0 0 0;minDistance:1;maxDistance:2;maxPolarAngle:100;minPolarAngle:60;minAzimuthAngle:-180;maxAzimuthAngle: 180;
                          " ></a-entity>  </a-scene>
    
<!--</a-entity>-->
</template>
<script>
    
    export default {
        name: 'masthead'
    }
</script>
<style>
    
</style>